import { Record } from "immutable";

export interface IProViaLineData {
  LineNo: string;
  ParentLine: string;
  Model: string;
  Description: string;
  Qty: string;
  PackageQty: string;
  PackageDesc: string;
  List: string;
  ExtList: string;
  Sell: string;
  ExtSell: string;
  TagNo: string;
  ImageURL: string;
  Coop: string;
  Comments: string;
  Options: string;
}

export interface IProViaLineRecord extends IProViaLineData {}

const defaultProViaLineProps: IProViaLineRecord = {
  LineNo: "",
  ParentLine: "",
  Model: "",
  Description: "",
  Qty: "",
  PackageQty: "",
  PackageDesc: "",
  List: "",
  ExtList: "",
  Sell: "",
  ExtSell: "",
  TagNo: "",
  ImageURL: "",
  Coop: "",
  Comments: "",
  Options: "",
};

export class ProViaLineRecord extends Record(defaultProViaLineProps) implements IProViaLineRecord {}

export const proViaLineFromJSON = (json: IProViaLineData): ProViaLineRecord => new ProViaLineRecord({ ...json });
